import { ensureArray, objectify } from '@lglp/utils';
import { compose, map } from 'ramda';

import {
  LOAD_DOCUMENTS_BY_IDS_SUCCESS,
  LOAD_DOCUMENT_BY_ID_SUCCESS,
  LOAD_DOCUMENT_BY_UID_SUCCESS,
  LOAD_PAGINATED_QUERY_SUCCESS,
  LOAD_SINGLE_TYPE_DOC_SUCCESS,
} from '../actions/prismic';

const cache: (value: []) => Record<string, any> = compose(
  map(Boolean),
  objectify('id'),
  ensureArray
);

const loaded = (state: LoadedState = {}, action: any = {}): LoadedState => {
  switch (action.type) {
    case LOAD_DOCUMENT_BY_ID_SUCCESS:
    case LOAD_DOCUMENT_BY_UID_SUCCESS:
    case LOAD_SINGLE_TYPE_DOC_SUCCESS:
    case LOAD_DOCUMENTS_BY_IDS_SUCCESS:
    case LOAD_PAGINATED_QUERY_SUCCESS:
      return {
        ...cache(action.payload?.result || []),
        ...state,
      };

    default:
      return state;
  }
};
export type LoadedState = Record<string, boolean>;
export default loaded;
